import { render, staticRenderFns } from "./LpInputTag.vue?vue&type=template&id=c3893de4&scoped=true"
import script from "./LpInputTag.vue?vue&type=script&lang=js"
export * from "./LpInputTag.vue?vue&type=script&lang=js"
import style0 from "./LpInputTag.vue?vue&type=style&index=0&id=c3893de4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3893de4",
  null
  
)

export default component.exports